import { memo } from 'react';
import { Grid, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { TemplateLink } from 'utils/link';
import { IndexListItemButton } from 'components/styles_components/list';
import useMobile from 'hooks/use_mobile';

const ListItem = ({ template }) => {
  const navigate = useNavigate();
  const isMobile = useMobile();

  const mobileContent = () => (
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
      <Grid size={{ xs: 12 }} textAlign="left">
        <Typography variant="button">{template.name}</Typography>
      </Grid>
    </Grid>
  );

  const desktopContent = () => (
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
      <Grid size={{ xs: 6 }} textAlign="left">
        <Typography variant="button">{template.name}</Typography>
      </Grid>
      <Grid size={{ xs: 2 }} textAlign="center">
        {template.periodCycle && template.periodNumber && (
          <FormattedMessage
            id={`inspection.period.${template.periodCycle}.count`}
            values={{ count: template.periodNumber }}
          />
        )}
      </Grid>
      <Grid size={{ xs: 2 }} textAlign="center">
        {template.templateFieldsTotal}
      </Grid>
      <Grid size={{ xs: 2 }} textAlign="center">
        {template.inspectionsTotal}
      </Grid>
    </Grid>
  );

  return (
    <IndexListItemButton
      onClick={() => {
        navigate(TemplateLink(template.id));
      }}
    >
      {isMobile ? mobileContent() : desktopContent()}
    </IndexListItemButton>
  );
};

export default memo(ListItem);
